import { Attributes, Misc, Validation } from '@singularsystems/neo-core';
import TemporalEntity from '../TemporalEntity';
import Investor from "./Investor";
import PortalUser from "../PortalUser/PortalUser";

export default class InvestorUser extends TemporalEntity {
    static typeName = "InvestorUser";

    constructor() {
        super();
        this.makeObservable();
    }

    public investorUserId: number = 0;

    @Attributes.Nullable()
    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public investorId: number | null = null;

    @Attributes.Serialisation(Misc.SerialiseType.FullOnly)
    public investorName: string = "";

    @Attributes.Nullable()
    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public portalUserId: number | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    @Attributes.Parent(() => Investor)
    public investorParent: Investor | null = null;

    @Attributes.NoTracking()
    @Attributes.Parent(() => PortalUser)
    public portalUserParent: PortalUser | null = null;

    protected static addBusinessRules(rules: Validation.Rules<InvestorUser>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.portalUserParent != null && c.investorId === null, "Investor is required").onProperties(c => c.investorId);
        rules.failWhen(c => c.investorParent != null && c.portalUserId === null, "User is required").onProperties(c => c.portalUserId);
    }

    public toString(): string {
        if (this.isNew) {
            return "New investor user";
        } else {
            return "Investor User";
        }
    }
}